// extracted by mini-css-extract-plugin
module.exports = {"body":"GSuiteLogin_body__qTHA9","container":"GSuiteLogin_container__3u0KS","image":"GSuiteLogin_image__27awI"};